import { useRef, useState } from "react";

import { useReactToPrint } from "react-to-print";

import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { Card } from "primereact/card";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { Toast } from "primereact/toast";

import Loading from "../../components/Loading";
import Menu from "../../components/Menu";

import api from "../../services/api";

const initialState = {
  teares: [],
  artigo: 'N',
  passadas: 0
}

export function ManutencaoRelatorio() {
  const [data, setData] = useState({ ...initialState });
  const [initialDate, setInitialDate] = useState(new Date());
  const [finalDate, setFinalDate] = useState(new Date());
  const [article, setArticle] = useState('N');

  const [loading, setLoading] = useState(false);
  const [printing, setPrinting] = useState(false);

  const toast = useRef();
  const ref = useRef();

  function formatDate(date) {
    if (date !== null && typeof date.getMonth === "function") {
      return (
        date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate()
      );
    }
    return "";
  }

  const handlePrint = useReactToPrint({
    content: () => ref.current,
    onBeforeGetContent: () => {
      return new Promise((resolve) => {
        setPrinting(true);
        setTimeout(() => {
          resolve();
        }, 500);
      });
    },
    onAfterPrint: () => {
      setPrinting(false);
    },
  });

  const getData = () => {
    setLoading(true);
    let formated1 = formatDate(initialDate);
    let formated2 = formatDate(finalDate);

    let json = { data_inicial: formated1, data_final: formated2 };
    if(article === 'S')
      json.artigo = 'S';
    api
      .get("manutencao/teares-batidas", { params: json })
      .then((response) => {
        setData(response.data);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  if (loading) {
    return <Loading />;
  }

  return (
    <div>
      <Menu />
      <Toast ref={toast} />
      <div className="p-fluid p-formgrid p-grid p-m-2">
        <div className="p-field p-col-3">
          <label htmlFor="artigo">Artigo: </label>
          <Dropdown 
            onChange={e => setArticle(e.value)}
            options={[
              { label: 'Não', value: 'N' },
              { label: 'Sim', value: 'S' },
            ]}
            value={article}
          />
        </div>
        <div className="p-field p-col-3">
          <label htmlFor="data_inicial">Data Inicial: </label>
          <Calendar
            dateFormat="dd/mm/yy"
            mask="99/99/9999"
            onChange={(e) => setInitialDate(e.value)}
            placeholder="Escolha a Data Inicial"
            value={initialDate}
          />
        </div>
        <div className="p-field p-col-3">
          <label htmlFor="data_final">Data Final: </label>
          <Calendar
            dateFormat="dd/mm/yy"
            mask="99/99/9999"
            onChange={(e) => setFinalDate(e.value)}
            placeholder="Escolha a Data Final"
            value={finalDate}
          />
        </div>
        <div className="p-field p-col-2 p-d-flex">
          <Button icon="pi pi-search" onClick={getData} style={{ alignSelf: 'end' }} />
        </div>
      </div>
      <Card className="p-m-1" title="Manutenção">
        <div className="p-d-flex p-flex-row p-jc-between">
          <h3>Passadas Total: {Intl.NumberFormat('pt-BR', { maximumFractionDigits: 0 }).format(data.passadas)}</h3>
          <Button className="p-m-1" icon="pi pi-print" onClick={handlePrint} />
        </div>
        <DataTable
          ref={ref}
          className="p-m-1"
          responsiveLayout="scroll"
          size="small"
          value={data.teares}
        >
          {data.artigo !== 'S' && (
            <Column header="Tear" field="tear" sortable style={{ width: '50%' }} bodyStyle={{ fontSize: 18 }} />
          )}
          {data.artigo === 'S' && (
            <Column header="Artigo" field="artigo" sortable style={{ width: '50%' }} />
          )}
          <Column header="Nº Passadas" sortable sortField="total" bodyStyle={{ fontSize: 18, fontWeigth: "bold" }}body={(rowData) => {
              return Intl.NumberFormat("pt-BR", { maximumFractionDigits: 0 }).format(rowData.total);
            }}
          />
          <Column header="Dias" field="dias" sortable />
          <Column header="Média" field="media" sortable body={(rowData) => {
            return Intl.NumberFormat("pt-BR", { maximumFractionDigits: 0 }).format(rowData.media);
          }} />
        </DataTable>
      </Card>
    </div>
  );
}
